import React, { useState, useEffect } from "react";
import { resolveImageUrl } from "@/components/ImageInput";

const PLACEHOLDER = "/player-placeholder.svg";

/**
 * Reliable player photo with graceful fallback.
 * Handles absolute URLs, data URIs, and backend-relative /api/files paths.
 */
export default function PlayerPhoto({ src, alt = "", aspect = "aspect-[3/4]", className = "", overlay = true, children }) {
  const [errored, setErrored] = useState(false);
  const resolved = resolveImageUrl(src);
  useEffect(() => { setErrored(false); }, [resolved]);
  const useSrc = !resolved || errored ? PLACEHOLDER : resolved;
  return (
    <div className={`relative ${aspect} bg-zinc-900 overflow-hidden ${className}`}>
      <img
        src={useSrc}
        alt={alt}
        loading="lazy"
        onError={() => setErrored(true)}
        className="absolute inset-0 w-full h-full object-cover"
      />
      {overlay && (
        <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.85) 100%)" }} />
      )}
      {children && (
        <div className="absolute inset-0 flex flex-col justify-between p-3">
          {children}
        </div>
      )}
    </div>
  );
}
